import { getAuth } from "../auth/publicUsers/authStorage";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function pushTokenSaveToken(param) {
    let loginData = getAuth();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post(`/Push/SaveToken`, param)

}
export async function pushTokenRegisterPublic(param) {
        return await createAxios().post(`/Push/RegisterPublic?Token=${param.token}`)
}